import React from 'react';
import useOnLoad from '../../../../hooks/queries/useOnLoad';
import { OfferBuyCards } from '../../../../shared/logicalComponents';
import AssetOptions from '../../AssetOptions/AssetOptions';
import LicenseMessage from '../../Messages/LicenseMessage/LicenseMessage';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex';

const SubscriptionLicenseForm = () => {
  const { response: { config: { config } = {} } = {} } = useOnLoad();
  const { selectedOption } = useSelectedIndex();

  if (!config) {
    return (
      <div data-testid="subscription-license-form-loading">Loading...</div>
    );
  }

  return (
    <div data-testid="subscription-license-form">
      <AssetOptions />
      <LicenseMessage />
      {selectedOption?.type !== 'customlicense' && <OfferBuyCards />}
    </div>
  );
};

export default SubscriptionLicenseForm;
